// Malayalam strings for the field screens owned by fieldA: Scan home, Asset quick view, Sync status, offline queue messages,
// Location contents sheet, Guest loaners, scanned-tag landing page. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (browser storage in use: {size})": " (ഉപയോഗത്തിലുള്ള ബ്രൗസർ സ്റ്റോറേജ്: {size})",
  " (Overdue {time})": " (വൈകി {time})",
  " A Repair Record was raised for the damaged item.": " കേടായ ഇനത്തിനായി ഒരു റിപ്പയർ റെക്കോർഡ് സൃഷ്ടിച്ചു.",
  " A replacement charge of {currency} {amount} was recorded.": " {currency} {amount} മാറ്റിസ്ഥാപിക്കൽ തുക രേഖപ്പെടുത്തി.",
  " Ask a storekeeper or the onboarding team to bind it.": " ഇത് ബന്ധിപ്പിക്കാൻ സ്റ്റോർകീപ്പറോടോ ഓൺബോർഡിംഗ് ടീമിനോടോ ആവശ്യപ്പെടുക.",
  " for {property}": " {property}-നായി",
  " · from offline data": " · ഓഫ്‌ലൈൻ ഡാറ്റയിൽ നിന്ന്",
  "\"{code}\" is not in the data prepared for offline use. Check the code, or try again when you are back online.": "\"{code}\" ഓഫ്‌ലൈൻ ഉപയോഗത്തിനായി തയ്യാറാക്കിയ ഡാറ്റയിൽ ഇല്ല. കോഡ് പരിശോധിക്കുക, അല്ലെങ്കിൽ ഓൺലൈനായ ശേഷം വീണ്ടും ശ്രമിക്കുക.",
  "(optional)": "(ഐച്ഛികം)",
  "({n} available)": "({n} ലഭ്യമാണ്)",
  ", inactive": ", നിഷ്ക്രിയം",
  "100% in good condition": "100% നല്ല അവസ്ഥയിൽ",
  "A Repair Record (or a replacement charge for an unregistered item) will be raised automatically and the item withdrawn from the fleet.": "ഒരു റിപ്പയർ റെക്കോർഡ് (അല്ലെങ്കിൽ രജിസ്റ്റർ ചെയ്യാത്ത ഇനത്തിന് മാറ്റിസ്ഥാപിക്കൽ തുക) സ്വയം സൃഷ്ടിക്കപ്പെടും, ഇനം ശേഖരത്തിൽ നിന്ന് പിൻവലിക്കും.",
  "Across {n} guest room": "{n} അതിഥി മുറിയിൽ",
  "Across {n} guest rooms": "{n} അതിഥി മുറികളിൽ",
  "Actions": "പ്രവർത്തനങ്ങൾ",
  "Actions taken offline wait here and sync in the order they were taken. Prepare for offline before a shift so rooms, count sheets and assets are on this device.": "ഓഫ്‌ലൈനായി ചെയ്ത പ്രവർത്തനങ്ങൾ ഇവിടെ കാത്തിരിക്കുകയും ചെയ്ത ക്രമത്തിൽ സമന്വയിപ്പിക്കുകയും ചെയ്യും. മുറികളും എണ്ണൽ ഷീറ്റുകളും ആസ്തികളും ഈ ഉപകരണത്തിൽ ഉണ്ടാകാൻ ഷിഫ്റ്റിന് മുമ്പ് ഓഫ്‌ലൈനിനായി തയ്യാറാക്കുക.",
  "Active": "സജീവം",
  "Active & Recent Guest Loans": "സജീവവും സമീപകാലവുമായ അതിഥി വായ്പകൾ",
  "Active On-Loan": "നിലവിൽ വായ്പയിൽ",
  "All Statuses": "എല്ലാ നിലകളും",
  "Asset": "ആസ്തി",
  "Asset quick view": "ആസ്തി ക്വിക്ക് വ്യൂ",
  "Asset quick view saved": "ആസ്തി ക്വിക്ക് വ്യൂ സംരക്ഷിച്ചു",
  "Asset tag or short code": "ആസ്തി ടാഗ് അല്ലെങ്കിൽ ഷോർട്ട് കോഡ്",
  "Audit": "ഓഡിറ്റ്",
  "Audit checklists": "ഓഡിറ്റ് ചെക്ക്‌ലിസ്റ്റുകൾ",
  "Audit scan": "ഓഡിറ്റ് സ്കാൻ",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipient).": "{item}-നായി {room} സൂപ്പർവൈസർമാർക്ക് ഓട്ടോമാറ്റിക് ഓർമ്മപ്പെടുത്തൽ അയച്ചു ({n} സ്വീകർത്താവ്).",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipients).": "{item}-നായി {room} സൂപ്പർവൈസർമാർക്ക് ഓട്ടോമാറ്റിക് ഓർമ്മപ്പെടുത്തൽ അയച്ചു ({n} സ്വീകർത്താക്കൾ).",
  "Bind this tag to an asset": "ഈ ടാഗ് ഒരു ആസ്തിയുമായി ബന്ധിപ്പിക്കുക",
  "Blind count": "ബ്ലൈൻഡ് എണ്ണൽ",
  "Camera preview": "ക്യാമറ പ്രിവ്യൂ",
  "Camera unavailable": "ക്യാമറ ലഭ്യമല്ല",
  "Camera unavailable ({msg}). Type the code printed under the tag instead.": "ക്യാമറ ലഭ്യമല്ല ({msg}). പകരം ടാഗിന് താഴെ അച്ചടിച്ച കോഡ് ടൈപ്പ് ചെയ്യുക.",
  "Cancel": "റദ്ദാക്കുക",
  "Category": "വിഭാഗം",
  "Choose a location": "ഒരു സ്ഥലം തിരഞ്ഞെടുക്കുക",
  "Choose a location to see what should be in it.": "അതിൽ എന്തൊക്കെ ഉണ്ടാകണമെന്ന് കാണാൻ ഒരു സ്ഥലം തിരഞ്ഞെടുക്കുക.",
  "Choose a room, floor, wing or building…": "ഒരു മുറി, നില, വിംഗ് അല്ലെങ്കിൽ കെട്ടിടം തിരഞ്ഞെടുക്കുക…",
  "Choose where the asset is going.": "ആസ്തി എവിടേക്കാണ് പോകുന്നതെന്ന് തിരഞ്ഞെടുക്കുക.",
  "Close": "അടയ്ക്കുക",
  "Completed": "പൂർത്തിയായി",
  "Condition": "അവസ്ഥ",
  "Condition now": "ഇപ്പോഴത്തെ അവസ്ഥ",
  "Condition on return": "തിരികെ നൽകുമ്പോഴുള്ള അവസ്ഥ",
  "Condition Rating *": "അവസ്ഥാ റേറ്റിംഗ് *",
  "Condition: {condition}": "അവസ്ഥ: {condition}",
  "Confirm Issue & Dispatch": "നൽകലും അയയ്ക്കലും സ്ഥിരീകരിക്കുക",
  "Confirm Return": "തിരികെ നൽകൽ സ്ഥിരീകരിക്കുക",
  "Confirm return of": "തിരികെ നൽകൽ സ്ഥിരീകരിക്കുക:",
  "Conflict": "വൈരുദ്ധ്യം",
  "Conflicts": "വൈരുദ്ധ്യങ്ങൾ",
  "Connection": "കണക്ഷൻ",
  "Could not read the selected photo": "തിരഞ്ഞെടുത്ത ഫോട്ടോ വായിക്കാനായില്ല",
  "Count sheets": "എണ്ണൽ ഷീറ്റുകൾ",
  "Counted": "എണ്ണിയത്",
  "Custodian": "സൂക്ഷിപ്പുകാരൻ",
  "Custody return": "കസ്റ്റഡി തിരികെ നൽകൽ",
  "Damage report": "കേടുപാട് റിപ്പോർട്ട്",
  "Damage reported ({ref}) with a photo.": "ഫോട്ടോ സഹിതം കേടുപാട് റിപ്പോർട്ട് ചെയ്തു ({ref}).",
  "Damage reported for {tag} ({ref}).": "{tag}-ന്റെ കേടുപാട് റിപ്പോർട്ട് ചെയ്തു ({ref}).",
  "Damage reported for {tag}.": "{tag}-ന്റെ കേടുപാട് റിപ്പോർട്ട് ചെയ്തു.",
  "Damage reported with a photo.": "ഫോട്ടോ സഹിതം കേടുപാട് റിപ്പോർട്ട് ചെയ്തു.",
  "Damaged": "കേടായത്",
  "Describe any damage": "ഏതെങ്കിലും കേടുപാട് വിവരിക്കുക",
  "Describe the damage (at least 5 characters).": "കേടുപാട് വിവരിക്കുക (കുറഞ്ഞത് 5 അക്ഷരങ്ങൾ).",
  "Discard": "ഉപേക്ഷിക്കുക",
  "Dismiss": "ഒഴിവാക്കുക",
  "Disposed": "നീക്കം ചെയ്തു",
  "Download progress": "ഡൗൺലോഡ് പുരോഗതി",
  "Downloading": "ഡൗൺലോഡ് ചെയ്യുന്നു",
  "Downloading the property and its locations": "പ്രോപ്പർട്ടിയും അതിന്റെ സ്ഥലങ്ങളും ഡൗൺലോഡ് ചെയ്യുന്നു",
  "Downloading…": "ഡൗൺലോഡ് ചെയ്യുന്നു…",
  "Downloads your open and assigned audits with the expected contents of up to 300 rooms, the count sheets of your property's stock points, first-walk rooms and the quick-view details of every asset, so a full shift works without a connection.": "നിങ്ങളുടെ തുറന്നതും നിയോഗിച്ചതുമായ ഓഡിറ്റുകൾ (300 മുറികൾ വരെയുള്ള പ്രതീക്ഷിത ഉള്ളടക്കം സഹിതം), നിങ്ങളുടെ പ്രോപ്പർട്ടിയിലെ സ്റ്റോക്ക് പോയിന്റുകളുടെ എണ്ണൽ ഷീറ്റുകൾ, ആദ്യ-നടത്ത മുറികൾ, ഓരോ ആസ്തിയുടെയും ക്വിക്ക് വ്യൂ എന്നിവ ഡൗൺലോഡ് ചെയ്യുന്നു; അതിനാൽ ഒരു മുഴുവൻ ഷിഫ്റ്റും കണക്ഷനില്ലാതെ പ്രവർത്തിക്കും.",
  "e.g. John Doe": "ഉദാ. ജോൺ ഡോ",
  "e.g. RM-201 or AOS7K9": "ഉദാ. RM-201 അല്ലെങ്കിൽ AOS7K9",
  "e.g. Room 402": "ഉദാ. മുറി 402",
  "Engineering": "എഞ്ചിനീയറിംഗ്",
  "Excellent": "മികച്ചത്",
  "Expected Return": "പ്രതീക്ഷിക്കുന്ന തിരികെ നൽകൽ",
  "Expected Return Window *": "പ്രതീക്ഷിക്കുന്ന തിരികെ നൽകൽ സമയം *",
  "Export CSV": "CSV എക്സ്പോർട്ട് ചെയ്യുക",
  "Export XLSX": "XLSX എക്സ്പോർട്ട് ചെയ്യുക",
  "Exporting…": "എക്സ്പോർട്ട് ചെയ്യുന്നു…",
  "Fair": "ശരാശരി",
  "Field app": "ഫീൽഡ് ആപ്പ്",
  "Filter by status": "നില അനുസരിച്ച് ഫിൽട്ടർ ചെയ്യുക",
  "Find an asset": "ഒരു ആസ്തി കണ്ടെത്തുക",
  "First-walk exception": "ആദ്യ-നടത്ത ഒഴിവാക്കൽ",
  "First-walk rooms": "ആദ്യ-നടത്ത മുറികൾ",
  "Food & Beverage": "ഭക്ഷണവും പാനീയവും",
  "Found in another room": "മറ്റൊരു മുറിയിൽ കണ്ടെത്തി",
  "from": "എന്നതിൽ നിന്ന്",
  "Front Office": "ഫ്രണ്ട് ഓഫീസ്",
  "Give a reason for the move (at least 3 characters).": "മാറ്റാനുള്ള കാരണം നൽകുക (കുറഞ്ഞത് 3 അക്ഷരങ്ങൾ).",
  "Good": "നല്ലത്",
  "Guest loaner issued successfully! {item} ({tag}) is out with {room}; return reminder scheduled for {when}.": "അതിഥി ലോണർ വിജയകരമായി നൽകി! {item} ({tag}) {room}-ൽ ആണ്; തിരികെ നൽകൽ ഓർമ്മപ്പെടുത്തൽ {when}-ന് ക്രമീകരിച്ചു.",
  "Guest Loaners & Overdue Tracker": "അതിഥി ലോണറുകളും വൈകിയവയുടെ ട്രാക്കറും",
  "Guest Name": "അതിഥിയുടെ പേര്",
  "Guest Room Number *": "അതിഥി മുറി നമ്പർ *",
  "Guest room number is required": "അതിഥി മുറി നമ്പർ ആവശ്യമാണ്",
  "Guest Services": "അതിഥി സേവനങ്ങൾ",
  "has been printed but is not attached to an asset, location or Stock Point yet.": "അച്ചടിച്ചെങ്കിലും ഇതുവരെ ഒരു ആസ്തിയുമായോ സ്ഥലവുമായോ സ്റ്റോക്ക് പോയിന്റുമായോ ബന്ധിപ്പിച്ചിട്ടില്ല.",
  "Housekeeping": "ഹൗസ്‌കീപ്പിംഗ്",
  "How urgent?": "എത്ര അടിയന്തരം?",
  "In repair": "അറ്റകുറ്റപ്പണിയിൽ",
  "In service": "സേവനത്തിൽ",
  "In store": "സ്റ്റോറിൽ",
  "In transit": "യാത്രയിൽ",
  "Inactive": "നിഷ്ക്രിയം",
  "Issue Guest Loaner Item": "അതിഥി ലോണർ ഇനം നൽകുക",
  "Issue Loaner Item": "ലോണർ ഇനം നൽകുക",
  "Issued": "നൽകിയത്",
  "IT & Telecom": "ഐടി & ടെലികോം",
  "Item": "ഇനം",
  "Kit:": "കിറ്റ്:",
  "Last audit": "അവസാന ഓഡിറ്റ്",
  "Last sync: {when}": "അവസാന സമന്വയം: {when}",
  "Last try: {error}": "അവസാന ശ്രമം: {error}",
  "Loading contents…": "ഉള്ളടക്കം ലോഡ് ചെയ്യുന്നു…",
  "Loading guest loans...": "അതിഥി വായ്പകൾ ലോഡ് ചെയ്യുന്നു...",
  "Loading property…": "പ്രോപ്പർട്ടി ലോഡ് ചെയ്യുന്നു…",
  "Loan Fleet Availability": "ലോൺ ശേഖരത്തിന്റെ ലഭ്യത",
  "Loaned At": "വായ്പ നൽകിയ സമയം",
  "Loaner Item": "ലോണർ ഇനം",
  "Location": "സ്ഥലം",
  "Location Contents Sheet": "സ്ഥല ഉള്ളടക്ക ഷീറ്റ്",
  "Locations saved": "സ്ഥലങ്ങൾ സംരക്ഷിച്ചു",
  "Look up": "തിരയുക",
  "Looking up the tag…": "ടാഗ് തിരയുന്നു…",
  "Low (minor / scheduled)": "കുറവ് (ചെറുത് / ഷെഡ്യൂൾ ചെയ്തത്)",
  "Missing": "കാണാനില്ല",
  "More than one asset matches": "ഒന്നിലധികം ആസ്തികൾ പൊരുത്തപ്പെടുന്നു",
  "Move": "മാറ്റുക",
  "Move of {tag} to {place} recorded and sent for approval.": "{tag} {place}-ലേക്ക് മാറ്റിയത് രേഖപ്പെടുത്തി, അംഗീകാരത്തിന് അയച്ചു.",
  "Move of {tag} to {place} recorded.": "{tag} {place}-ലേക്ക് മാറ്റിയത് രേഖപ്പെടുത്തി.",
  "Needs your attention": "നിങ്ങളുടെ ശ്രദ്ധ ആവശ്യമാണ്",
  "Never": "ഒരിക്കലുമില്ല",
  "New": "പുതിയത്",
  "Next": "അടുത്തത്",
  "No conflicts. If the server refuses a synced action (for example the item was moved, the audit was completed or the count was already submitted), it appears here for you to retry, discard or open.": "വൈരുദ്ധ്യങ്ങളില്ല. സമന്വയിപ്പിച്ച ഒരു പ്രവർത്തനം സെർവർ നിരസിച്ചാൽ (ഉദാ. ഇനം മാറ്റി, ഓഡിറ്റ് പൂർത്തിയായി, അല്ലെങ്കിൽ എണ്ണം ഇതിനകം സമർപ്പിച്ചു), വീണ്ടും ശ്രമിക്കാനോ ഉപേക്ഷിക്കാനോ തുറക്കാനോ അത് ഇവിടെ കാണിക്കും.",
  "No guest loans found.": "അതിഥി വായ്പകളൊന്നും കണ്ടെത്തിയില്ല.",
  "No loaner items registered": "ലോണർ ഇനങ്ങളൊന്നും രജിസ്റ്റർ ചെയ്തിട്ടില്ല",
  "No locations are available offline. Prepare for offline on the Sync status page first.": "ഓഫ്‌ലൈനായി സ്ഥലങ്ങളൊന്നും ലഭ്യമല്ല. ആദ്യം സമന്വയ നില പേജിൽ ഓഫ്‌ലൈനിനായി തയ്യാറാക്കുക.",
  "No pooled stock is held here.": "ഇവിടെ പൂൾ ചെയ്ത സ്റ്റോക്ക് ഇല്ല.",
  "No returns yet today": "ഇന്ന് ഇതുവരെ തിരികെ നൽകലുകളില്ല",
  "No tagged assets here. Stamp a kit to create the room's expected contents.": "ഇവിടെ ടാഗ് ചെയ്ത ആസ്തികളില്ല. മുറിയുടെ പ്രതീക്ഷിത ഉള്ളടക്കം സൃഷ്ടിക്കാൻ ഒരു കിറ്റ് സ്റ്റാമ്പ് ചെയ്യുക.",
  "No {item} is currently available": "നിലവിൽ {item} ലഭ്യമല്ല",
  "Normal": "സാധാരണ",
  "Not accepted": "സ്വീകരിച്ചില്ല",
  "Not assigned": "നിയോഗിച്ചിട്ടില്ല",
  "Not audited yet": "ഇതുവരെ ഓഡിറ്റ് ചെയ്തിട്ടില്ല",
  "Notes": "കുറിപ്പുകൾ",
  "Nothing has been prepared on this device yet.": "ഈ ഉപകരണത്തിൽ ഇതുവരെ ഒന്നും തയ്യാറാക്കിയിട്ടില്ല.",
  "Nothing is waiting. Scans, counts, bindings and moves you make offline are kept here until they reach the server.": "ഒന്നും കാത്തിരിക്കുന്നില്ല. ഓഫ്‌ലൈനായി ചെയ്യുന്ന സ്കാനുകൾ, എണ്ണലുകൾ, ബന്ധിപ്പിക്കലുകൾ, മാറ്റങ്ങൾ എന്നിവ സെർവറിൽ എത്തുന്നതുവരെ ഇവിടെ സൂക്ഷിക്കും.",
  "Nothing overdue": "വൈകിയതൊന്നുമില്ല",
  "Nudge guests from the list below": "താഴെയുള്ള പട്ടികയിൽ നിന്ന് അതിഥികളെ ഓർമ്മിപ്പിക്കുക",
  "Nudge Room": "മുറിയെ ഓർമ്മിപ്പിക്കുക",
  "Offline": "ഓഫ്‌ലൈൻ",
  "Offline - syncs automatically when back online": "ഓഫ്‌ലൈൻ - ഓൺലൈനാകുമ്പോൾ സ്വയം സമന്വയിപ്പിക്കും",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online (photos need a connection, so it is sent without one).": "ഓഫ്‌ലൈൻ: {tag}-ന്റെ കേടുപാട് റിപ്പോർട്ട് ഈ ഉപകരണത്തിൽ സംരക്ഷിച്ചു, ഓൺലൈനാകുമ്പോൾ അയയ്ക്കും (ഫോട്ടോകൾക്ക് കണക്ഷൻ ആവശ്യമാണ്, അതിനാൽ ഫോട്ടോ ഇല്ലാതെ അയയ്ക്കും).",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online.": "ഓഫ്‌ലൈൻ: {tag}-ന്റെ കേടുപാട് റിപ്പോർട്ട് ഈ ഉപകരണത്തിൽ സംരക്ഷിച്ചു, ഓൺലൈനാകുമ്പോൾ അയയ്ക്കും.",
  "Offline: the move of {tag} is saved on this device and recorded when you are back online.": "ഓഫ്‌ലൈൻ: {tag} മാറ്റിയത് ഈ ഉപകരണത്തിൽ സംരക്ഷിച്ചു, ഓൺലൈനാകുമ്പോൾ രേഖപ്പെടുത്തും.",
  "Offline: the new condition of {tag} is saved on this device and recorded when you are back online.": "ഓഫ്‌ലൈൻ: {tag}-ന്റെ പുതിയ അവസ്ഥ ഈ ഉപകരണത്തിൽ സംരക്ഷിച്ചു, ഓൺലൈനാകുമ്പോൾ രേഖപ്പെടുത്തും.",
  "Offline: the return of {tag} is saved on this device and recorded when you are back online.": "ഓഫ്‌ലൈൻ: {tag} തിരികെ നൽകിയത് ഈ ഉപകരണത്തിൽ സംരക്ഷിച്ചു, ഓൺലൈനാകുമ്പോൾ രേഖപ്പെടുത്തും.",
  "On hand": "കൈവശമുള്ളത്",
  "Online": "ഓൺലൈൻ",
  "Open": "തുറക്കുക",
  "Open record": "റെക്കോർഡ് തുറക്കുക",
  "Open the first scan walk": "ആദ്യ സ്കാൻ നടത്തം തുറക്കുക",
  "Open the full record": "പൂർണ്ണ റെക്കോർഡ് തുറക്കുക",
  "Open {asset}": "{asset} തുറക്കുക",
  "Opening the asset, location or Stock Point this label belongs to.": "ഈ ലേബൽ ഉൾപ്പെടുന്ന ആസ്തിയോ സ്ഥലമോ സ്റ്റോക്ക് പോയിന്റോ തുറക്കുന്നു.",
  "Or type the code (room code, asset tag or the short code under the barcode)": "അല്ലെങ്കിൽ കോഡ് ടൈപ്പ് ചെയ്യുക (മുറി കോഡ്, ആസ്തി ടാഗ് അല്ലെങ്കിൽ ബാർകോഡിന് താഴെയുള്ള ഷോർട്ട് കോഡ്)",
  "Out of service": "സേവനത്തിന് പുറത്ത്",
  "Overdue": "വൈകിയത്",
  "Overdue Past Deadline": "സമയപരിധി കഴിഞ്ഞവ",
  "Par": "പാർ",
  "Pending": "തീർപ്പാകാത്തത്",
  "Photo": "ഫോട്ടോ",
  "Photos must be JPEG, PNG or WebP images.": "ഫോട്ടോകൾ JPEG, PNG അല്ലെങ്കിൽ WebP ആയിരിക്കണം.",
  "Photos need a connection; the report is saved without one and sent when you are back online.": "ഫോട്ടോകൾക്ക് കണക്ഷൻ ആവശ്യമാണ്; റിപ്പോർട്ട് ഫോട്ടോ ഇല്ലാതെ സംരക്ഷിച്ച് ഓൺലൈനാകുമ്പോൾ അയയ്ക്കും.",
  "Point the camera at a room's door tag to start its audit, or at an asset's tag to see its status and act on it.": "മുറിയുടെ ഓഡിറ്റ് തുടങ്ങാൻ ക്യാമറ വാതിലിലെ ടാഗിലേക്ക് പിടിക്കുക, അല്ലെങ്കിൽ ആസ്തിയുടെ നില കാണാനും നടപടിയെടുക്കാനും അതിന്റെ ടാഗിലേക്ക്.",
  "Pooled stock ({n})": "പൂൾ ചെയ്ത സ്റ്റോക്ക് ({n})",
  "Poor (damaged)": "മോശം (കേടായത്)",
  "Prepare for offline": "ഓഫ്‌ലൈനിനായി തയ്യാറാക്കുക",
  "Prepared {when}": "തയ്യാറാക്കിയത് {when}",
  "Preparing needs a connection.": "തയ്യാറാക്കാൻ കണക്ഷൻ ആവശ്യമാണ്.",
  "Previous": "മുമ്പത്തേത്",
  "Print": "പ്രിന്റ് ചെയ്യുക",
  "Printed {when}": "അച്ചടിച്ചത് {when}",
  "Property": "പ്രോപ്പർട്ടി",
  "Quick Return": "പെട്ടെന്നുള്ള തിരികെ നൽകൽ",
  "Reason": "കാരണം",
  "Reason for the move": "മാറ്റാനുള്ള കാരണം",
  "Receiving department": "സ്വീകരിക്കുന്ന വകുപ്പ്",
  "Recondition": "പുനഃക്രമീകരിക്കുക",
  "Record move": "മാറ്റം രേഖപ്പെടുത്തുക",
  "Record return": "തിരികെ നൽകൽ രേഖപ്പെടുത്തുക",
  "Refresh offline data": "ഓഫ്‌ലൈൻ ഡാറ്റ പുതുക്കുക",
  "Report damage": "കേടുപാട് റിപ്പോർട്ട് ചെയ്യുക",
  "Report issue": "പ്രശ്നം റിപ്പോർട്ട് ചെയ്യുക",
  "Reports": "റിപ്പോർട്ടുകൾ",
  "Retired": "വിരമിച്ചത്",
  "Retry": "വീണ്ടും ശ്രമിക്കുക",
  "Return": "തിരികെ നൽകുക",
  "Return from custody": "കസ്റ്റഡിയിൽ നിന്ന് തിരികെ",
  "Returned": "തിരികെ ലഭിച്ചു",
  "Returned damaged": "കേടായി തിരികെ ലഭിച്ചു",
  "Returned Today": "ഇന്ന് തിരികെ ലഭിച്ചവ",
  "Room #": "മുറി #",
  "Room sign-off": "മുറി സൈൻ-ഓഫ്",
  "Save condition": "അവസ്ഥ സംരക്ഷിക്കുക",
  "Saved for offline use - details may have changed since.": "ഓഫ്‌ലൈൻ ഉപയോഗത്തിനായി സംരക്ഷിച്ചത് - വിവരങ്ങൾ മാറിയിരിക്കാം.",
  "Scan": "സ്കാൻ",
  "Scan a room or asset tag. A room offers its audit; an asset opens its quick view. Works offline once the shift is prepared.": "ഒരു മുറിയുടെയോ ആസ്തിയുടെയോ ടാഗ് സ്കാൻ ചെയ്യുക. മുറി അതിന്റെ ഓഡിറ്റ് നൽകും; ആസ്തി അതിന്റെ ക്വിക്ക് വ്യൂ തുറക്കും. ഷിഫ്റ്റ് തയ്യാറാക്കിയാൽ ഓഫ്‌ലൈനായും പ്രവർത്തിക്കും.",
  "Scan a tag or type the code printed under it.": "ഒരു ടാഗ് സ്കാൻ ചെയ്യുക അല്ലെങ്കിൽ അതിന് താഴെ അച്ചടിച്ച കോഡ് ടൈപ്പ് ചെയ്യുക.",
  "Scan an asset tag from Scan, or type its code below.": "സ്കാനിൽ നിന്ന് ഒരു ആസ്തി ടാഗ് സ്കാൻ ചെയ്യുക, അല്ലെങ്കിൽ അതിന്റെ കോഡ് താഴെ ടൈപ്പ് ചെയ്യുക.",
  "Scanned Tag": "സ്കാൻ ചെയ്ത ടാഗ്",
  "Search loans": "വായ്പകൾ തിരയുക",
  "Search room, guest, item...": "മുറി, അതിഥി, ഇനം തിരയുക...",
  "Select an expected return window": "പ്രതീക്ഷിക്കുന്ന തിരികെ നൽകൽ സമയം തിരഞ്ഞെടുക്കുക",
  "Select Available Equipment *": "ലഭ്യമായ ഉപകരണം തിരഞ്ഞെടുക്കുക *",
  "Select item...": "ഇനം തിരഞ്ഞെടുക്കുക...",
  "Select the equipment to issue": "നൽകേണ്ട ഉപകരണം തിരഞ്ഞെടുക്കുക",
  "Send damage report": "കേടുപാട് റിപ്പോർട്ട് അയയ്ക്കുക",
  "Serial": "സീരിയൽ",
  "Starting": "ആരംഭിക്കുന്നു",
  "Status": "നില",
  "Status, condition and last audit, with the actions you can take here. Actions work offline and sync later.": "നില, അവസ്ഥ, അവസാന ഓഡിറ്റ് എന്നിവയും ഇവിടെ ചെയ്യാവുന്ന പ്രവർത്തനങ്ങളും. പ്രവർത്തനങ്ങൾ ഓഫ്‌ലൈനായി പ്രവർത്തിക്കുകയും പിന്നീട് സമന്വയിപ്പിക്കുകയും ചെയ്യും.",
  "Stop": "നിർത്തുക",
  "Stored on this device: {size}": "ഈ ഉപകരണത്തിൽ സംഭരിച്ചത്: {size}",
  "Storekeeper": "സ്റ്റോർകീപ്പർ",
  "Sync finished: {parts}.": "സമന്വയം പൂർത്തിയായി: {parts}.",
  "Sync now": "ഇപ്പോൾ സമന്വയിപ്പിക്കുക",
  "Sync paused; it resumes automatically": "സമന്വയം താൽക്കാലികമായി നിർത്തി; സ്വയം പുനരാരംഭിക്കും",
  "Sync status": "സമന്വയ നില",
  "Syncing…": "സമന്വയിപ്പിക്കുന്നു…",
  "Tag": "ടാഗ്",
  "Tag binding": "ടാഗ് ബന്ധിപ്പിക്കൽ",
  "Tag not bound yet": "ടാഗ് ഇതുവരെ ബന്ധിപ്പിച്ചിട്ടില്ല",
  "Tag {code} belongs to a stock point. Open Blind Counts to count it.": "ടാഗ് {code} ഒരു സ്റ്റോക്ക് പോയിന്റിന്റേതാണ്. എണ്ണാൻ ബ്ലൈൻഡ് കൗണ്ട്സ് തുറക്കുക.",
  "Tag {code} has been retired. Replace the label with a new tag.": "ടാഗ് {code} വിരമിച്ചു. ലേബൽ പുതിയ ടാഗ് ഉപയോഗിച്ച് മാറ്റുക.",
  "Tag {code} is no longer in use and cannot be bound again. Replace the label with a new tag.": "ടാഗ് {code} ഇനി ഉപയോഗത്തിലില്ല, വീണ്ടും ബന്ധിപ്പിക്കാനാവില്ല. ലേബൽ പുതിയ ടാഗ് ഉപയോഗിച്ച് മാറ്റുക.",
  "Tag {code} is not attached to an asset yet. Bind it during the first scan walk.": "ടാഗ് {code} ഇതുവരെ ഒരു ആസ്തിയുമായി ബന്ധിപ്പിച്ചിട്ടില്ല. ആദ്യ സ്കാൻ നടത്തത്തിൽ ബന്ധിപ്പിക്കുക.",
  "Tag: {tag}": "ടാഗ്: {tag}",
  "Tagged assets ({n})": "ടാഗ് ചെയ്ത ആസ്തികൾ ({n})",
  "taken {when}": "ചെയ്തത് {when}",
  "That tag is not attached to an asset.": "ആ ടാഗ് ഒരു ആസ്തിയുമായി ബന്ധിപ്പിച്ചിട്ടില്ല.",
  "The action was not accepted": "പ്രവർത്തനം സ്വീകരിച്ചില്ല",
  "the asset it was on": "ഇത് ഉണ്ടായിരുന്ന ആസ്തി",
  "The download needs a connection. Try again when you are online.": "ഡൗൺലോഡിന് കണക്ഷൻ ആവശ്യമാണ്. ഓൺലൈനാകുമ്പോൾ വീണ്ടും ശ്രമിക്കുക.",
  "The label may belong to another property, or the code was read incorrectly. Try typing the short code printed under the barcode.": "ലേബൽ മറ്റൊരു പ്രോപ്പർട്ടിയുടേതാകാം, അല്ലെങ്കിൽ കോഡ് തെറ്റായി വായിച്ചതാകാം. ബാർകോഡിന് താഴെ അച്ചടിച്ച ഷോർട്ട് കോഡ് ടൈപ്പ് ചെയ്ത് നോക്കുക.",
  "the new location": "പുതിയ സ്ഥലം",
  "The record changed while you were offline": "നിങ്ങൾ ഓഫ്‌ലൈനായിരിക്കെ റെക്കോർഡ് മാറി",
  "The tag could not be looked up": "ടാഗ് തിരയാനായില്ല",
  "This asset was not found, or it belongs to a property you cannot see.": "ഈ ആസ്തി കണ്ടെത്തിയില്ല, അല്ലെങ്കിൽ നിങ്ങൾക്ക് കാണാനാകാത്ത പ്രോപ്പർട്ടിയുടേതാണ്.",
  "This browser cannot read tags with the camera. Type the code printed under the tag, or use a handheld scanner into the field below.": "ഈ ബ്രൗസറിന് ക്യാമറ ഉപയോഗിച്ച് ടാഗുകൾ വായിക്കാനാവില്ല. ടാഗിന് താഴെ അച്ചടിച്ച കോഡ് ടൈപ്പ് ചെയ്യുക, അല്ലെങ്കിൽ താഴെയുള്ള ഫീൽഡിൽ ഹാൻഡ്‌ഹെൽഡ് സ്കാനർ ഉപയോഗിക്കുക.",
  "This property has no locations yet": "ഈ പ്രോപ്പർട്ടിക്ക് ഇതുവരെ സ്ഥലങ്ങളില്ല",
  "This tag has been retired": "ഈ ടാഗ് വിരമിച്ചു",
  "To location": "ലക്ഷ്യ സ്ഥലം",
  "Track loaner items issued to guest rooms and follow up on overdue returns.": "അതിഥി മുറികൾക്ക് നൽകിയ ലോണർ ഇനങ്ങൾ ട്രാക്ക് ചെയ്യുക, വൈകിയ തിരികെ നൽകലുകൾ പിന്തുടരുക.",
  "Urgent (guest-facing / safety)": "അടിയന്തരം (അതിഥികളെ ബാധിക്കുന്നത് / സുരക്ഷ)",
  "Verified": "സ്ഥിരീകരിച്ചു",
  "Waiting": "കാത്തിരിക്കുന്നു",
  "Waiting to sync": "സമന്വയത്തിനായി കാത്തിരിക്കുന്നു",
  "We could not find this tag": "ഈ ടാഗ് കണ്ടെത്താനായില്ല",
  "What is in a room right now: tagged assets one by one and pooled stock against par. Pick a floor or wing to print one sheet per room.": "ഇപ്പോൾ മുറിയിൽ എന്താണുള്ളത്: ടാഗ് ചെയ്ത ആസ്തികൾ ഓരോന്നായി, പാറിനെതിരെ പൂൾ ചെയ്ത സ്റ്റോക്ക്. ഓരോ മുറിക്കും ഒരു ഷീറ്റ് പ്രിന്റ് ചെയ്യാൻ ഒരു നിലയോ വിംഗോ തിരഞ്ഞെടുക്കുക.",
  "What is wrong?": "എന്താണ് പ്രശ്നം?",
  "Will retry": "വീണ്ടും ശ്രമിക്കും",
  "Written off": "എഴുതിത്തള്ളി",
  "You are offline and nothing has been prepared for offline use yet. Open Sync status and choose Prepare for offline before your next shift.": "നിങ്ങൾ ഓഫ്‌ലൈനാണ്, ഓഫ്‌ലൈൻ ഉപയോഗത്തിനായി ഇതുവരെ ഒന്നും തയ്യാറാക്കിയിട്ടില്ല. അടുത്ത ഷിഫ്റ്റിന് മുമ്പ് സമന്വയ നില തുറന്ന് ഓഫ്‌ലൈനിനായി തയ്യാറാക്കുക തിരഞ്ഞെടുക്കുക.",
  "You are offline. Actions stay on this device and sync automatically when the connection returns.": "നിങ്ങൾ ഓഫ്‌ലൈനാണ്. പ്രവർത്തനങ്ങൾ ഈ ഉപകരണത്തിൽ തുടരുകയും കണക്ഷൻ തിരികെ വരുമ്പോൾ സ്വയം സമന്വയിപ്പിക്കുകയും ചെയ്യും.",
  "Your role can view this asset but has no actions on it.": "നിങ്ങളുടെ റോളിന് ഈ ആസ്തി കാണാം, പക്ഷേ അതിൽ പ്രവർത്തനങ്ങളൊന്നുമില്ല.",
  "Your role has no field actions for a room. Scan an asset tag to see the asset.": "നിങ്ങളുടെ റോളിന് മുറിക്കായി ഫീൽഡ് പ്രവർത്തനങ്ങളില്ല. ആസ്തി കാണാൻ ആസ്തി ടാഗ് സ്കാൻ ചെയ്യുക.",
  "Your session has expired. Sign in again to sync; nothing on this device is lost.": "നിങ്ങളുടെ സെഷൻ കാലഹരണപ്പെട്ടു. സമന്വയിപ്പിക്കാൻ വീണ്ടും സൈൻ ഇൻ ചെയ്യുക; ഈ ഉപകരണത്തിലെ ഒന്നും നഷ്ടപ്പെടില്ല.",
  "{checklists} room checklists ({rooms} rooms, {batches} open audit)": "{checklists} മുറി ചെക്ക്‌ലിസ്റ്റുകൾ ({rooms} മുറികൾ, {batches} തുറന്ന ഓഡിറ്റ്)",
  "{checklists} room checklists ({rooms} rooms, {batches} open audits)": "{checklists} മുറി ചെക്ക്‌ലിസ്റ്റുകൾ ({rooms} മുറികൾ, {batches} തുറന്ന ഓഡിറ്റുകൾ)",
  "{code} is a room, not an asset. Open it from Scan.": "{code} ഒരു മുറിയാണ്, ആസ്തിയല്ല. സ്കാനിൽ നിന്ന് തുറക്കുക.",
  "{item} marked as Returned ({condition}) and restored to active housekeeping inventory.": "{item} തിരികെ ലഭിച്ചു ({condition}) എന്ന് അടയാളപ്പെടുത്തി, സജീവ ഹൗസ്‌കീപ്പിംഗ് ഇൻവെന്ററിയിലേക്ക് തിരികെ ചേർത്തു.",
  "{item} marked as Returned ({condition}) and withdrawn from the loaner fleet.": "{item} തിരികെ ലഭിച്ചു ({condition}) എന്ന് അടയാളപ്പെടുത്തി, ലോണർ ശേഖരത്തിൽ നിന്ന് പിൻവലിച്ചു.",
  "{n} assets for quick view": "ക്വിക്ക് വ്യൂവിനായി {n} ആസ്തികൾ",
  "{n} conflict": "{n} വൈരുദ്ധ്യം",
  "{n} conflicts": "{n} വൈരുദ്ധ്യങ്ങൾ",
  "{n} count sheets": "{n} എണ്ണൽ ഷീറ്റുകൾ",
  "{n} first-walk rooms": "{n} ആദ്യ-നടത്ത മുറികൾ",
  "{n} Item": "{n} ഇനം",
  "{n} Items": "{n} ഇനങ്ങൾ",
  "{n} items could not be downloaded": "{n} ഇനങ്ങൾ ഡൗൺലോഡ് ചെയ്യാനായില്ല",
  "{n} loans": "{n} വായ്പകൾ",
  "{n} locations": "{n} സ്ഥലങ്ങൾ",
  "{n} not accepted": "{n} സ്വീകരിച്ചില്ല",
  "{n} returned damaged": "{n} കേടായി തിരികെ ലഭിച്ചു",
  "{n} synced": "{n} സമന്വയിപ്പിച്ചു",
  "{pct}% in housekeeping store": "{pct}% ഹൗസ്‌കീപ്പിംഗ് സ്റ്റോറിൽ",
  "{tag} is now graded {grade}.": "{tag} ഇപ്പോൾ {grade} ആയി ഗ്രേഡ് ചെയ്തു.",
  "{tag} returned in {condition} condition.": "{tag} {condition} അവസ്ഥയിൽ തിരികെ ലഭിച്ചു.",
  "· {n} need attention": "· {n} ശ്രദ്ധ ആവശ്യമാണ്",
  "· {n} waiting to sync": "· {n} സമന്വയത്തിനായി കാത്തിരിക്കുന്നു",
};
